export const SERVER_HOST: string = process.env.REACT_APP_SERVER_HOST as string;
export const IMAGE_HOST: string = process.env.REACT_APP_IMAGE_HOST as string;
export const RECAPTCHA_SITE_KEY: string = process.env
  .REACT_APP_RECAPTCHA_SITE_KEY as string;
